/**
 * Created by andrey on 08.08.2025
 */

cc.CallFunc = function (selector, selectorTarget, data) {
    cc.ActionInstant.prototype.constructor.call(this);

    this.initWithFunction(selector, selectorTarget, data);
};

cc.CallFunc.prototype = Object.assign(Object.create(cc.ActionInstant.prototype), {
    constructor: cc.CallFunc,

    initWithFunction: function (selector, selectorTarget, data) {
        if (selector) {
            this._function = selector;
        }
        if (selectorTarget) {
            this._selectorTarget = selectorTarget;
        }
        if (data !== undefined) {
            this._data = data;
        }
        return true;
    },

    execute: function () {
        if (this._function) {
            this._function.call(this._selectorTarget, this.target, this._data);
        }
    },

    update: function () {
        this.execute();
    }
});

cc.callFunc = (selector, selectorTarget, data) => new cc.CallFunc(selector, selectorTarget, data);
